module.exports = __webpack_public_path__ + "static/media/6B.28e47c25.png";